<template>
    <div class="page indexCont">
        <div class="mobileHeader">
            {{companyName}}
        </div>
        <div class="mainCont">
            <!-- 顶部 -->
            <el-row :gutter="10" class="mainTop removeMargin">
                <!-- 侧边导航 -->
                <el-col :xs="24" :sm="6" :md="6" :lg="6" class="removePading">
                    <div class="asideNav">
                        <!-- <ul @click="goPage('/index')">
                            <li class="home"><img src="../../../assets/images/common/home2.png" alt=""></li>
                            <li>首页</li>
                        </ul> -->
                        <!-- <ul @click="goPage('/train')">
                            <li class="my"><img src="../../../assets/images/common/my2.png" alt=""></li>
                            <li>培训中心</li>
                        </ul> -->
                        <!-- <ul @click="goPage('/test')">
                            <li class="cart"><img src="../../../assets/images/common/cart2.png" alt=""></li>
                            <li>考试中心</li>
                        </ul>
                        <ul @click="goPage('/trainRecord')">
                            <li class="collect"><img src="../../../assets/images/common/profile2.png" alt=""></li>
                            <li>学习成就</li>
                        </ul> -->
                        <!-- <ul @click="goPage('/collect')">
                            <li class="collect"><img src="../../../assets/images/common/collect2.png" alt=""></li>
                            <li>我的收藏</li>
                        </ul> -->
                        <!-- <ul @click="learnGuide(4)">
                            <li class="mis"><img src="../../../assets/images/common/help.png" alt=""></li>
                            <li>帮助中心</li>
                        </ul> -->
                        <div class="training" @click="goPage('/train')">
                            <div class="image"><img src="../../../assets/images/common/my2.png" alt=""></div>
                            <div class="text">
                                <div class="chinese">培训中心</div>
                                <div class="english">Training Center</div>
                            </div>
                        </div>
                        <div class="training" @click="goPage('/test')">
                            <div class="image"><img src="../../../assets/images/common/cart2.png" alt=""></div>
                            <div class="text">
                                <div class="chinese">考试中心</div>
                                <div class="english">Exam Center</div>
                            </div>
                        </div>
                        <div class="training" @click="goPage('/trainRecord')">
                            <div class="image"><img src="../../../assets/images/common/profile2.png" alt=""></div>
                            <div class="text">
                                <div class="chinese">学习成就</div>
                                <div class="english">Learning Record</div>
                            </div>
                        </div>
                        <div class="training" @click="learnGuide(4)">
                            <div class="image"><img src="../../../assets/images/common/help.png" alt=""></div>
                            <div class="text">
                                <div class="chinese">帮助中心</div>
                                <div class="english">Help</div>
                            </div>
                        </div>
                        
                    </div>
                </el-col>
                <el-col :xs="24" :sm="18" :md="18" :lg="18" class="removePading">
                    <!-- 轮播 -->
                    <div ref="swiper-container" class="swiper-container banner" v-if="!isShow">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item,index) in swiperData" :key="index">
                                <img :src="$config.baseApi + item" alt="">
                            </div>
                        </div>
                        <div ref="swiper-pagination" class="swiper-pagination positionPag"></div>
                    </div>
                    <!-- 默认数据 -->
                     <div ref="swiper-container" class="swiper-container banner" v-if="isShow">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img src="../../../assets/images/home/banner1.jpg" alt="">
                            </div>
                            <div class="swiper-slide">
                                <img src="../../../assets/images/home/banner2.png" alt="">
                            </div>
                        </div>
                        <div ref="swiper-pagination" class="swiper-pagination positionPag"></div>
                    </div>
                </el-col>
            </el-row>
            <div class="mobileNav">
                <div class="navItem" @click="goPage('./test')">
                    <div class="navImg"></div>
                    <div class="navTxt">我的考试</div>
                </div>
                <div class="navItem" @click="goPage('./train')">
                    <div class="navImg"></div>
                    <div class="navTxt">培训中心</div>
                </div>
                 <div class="navItem" @click="goPage('./trainRecord')">
                    <div class="navImg"></div>
                    <div class="navTxt">学习成就</div>
                </div>
                <div class="navItem" @click="goPage('./collect')">
                    <div class="navImg"></div>
                    <div class="navTxt">我的收藏</div>
                </div>
                <div class="navItem" @click="goPage('./mistakes')">
                    <div class="navImg"></div>
                    <div class="navTxt">错题集</div>
                </div>
                <!-- @click="goPage('./help')" -->
                <div class="navItem" @click="learnGuide(4)">
                    <div class="navImg"></div>
                    <div class="navTxt">帮助中心</div>
                </div>
                <div class="navItem" @click="goPage('./queryCertificate')">
                    <div class="navImg"></div>
                    <div class="navTxt">证书查询</div>
                </div>
            </div>
            <div class="mobileLearnTime">
                <div>
                    <img src="../../../assets/images/common/time.png" alt=""><span>学习时长：366h</span>
                </div>
                <div>
                    <img src="../../../assets/images/common/book.png" alt=""><span>证书总数：6</span>
                </div>
            </div>
            <!-- 考试和公告 -->
            <el-row :gutter="10" class="mainTop removeMargin">
                <el-col :xs="24" :sm="15" :md="15" :lg="15" class="removePading">
                    <div class="testCenter">
                        <div class="comHeader">
                            <span>考试中心(Exam Center)</span>
                            <span @click="goPage('./test')">更多(more)</span>
                        </div>
                        <div class="comCont" v-if="!listShow">
                            <div v-for="(item,index) in paperDataList" :key="index" @click="goPage('./goTest?companyId='+ item.companyId +'&paperId=' + item.paperId + '&url=index')">
                                <span>【{{item.parentCategoryName ? item.parentCategoryName : "暂无"}}】{{item.paperName}}</span>
                                <span class="lock2_p"><img class="lock2" v-show="item.locked == 1 ? true : false" src="../../../assets/images/common/lock3.png" alt="">{{item.pushTime ? item.pushTime.slice(0,10) : "暂无时间"}}</span>
                            </div>
                        </div>
                        <div class="noData" v-if="listShow">暂无数据</div>
                    </div>
                </el-col>
                <!-- 公告 -->
                <el-col :xs="24" :sm="9" :md="9" :lg="9" class="removePading">
                    <div class="testCenter newsCenter">
                        <div class="comHeader">
                            <span>新闻公告(Notice)</span>
                            <span></span>
                        </div>
                        <div class="comCont" v-if="!newsShow">
                            <!-- <div @click="learnGuide('news1')">
                                <span>上海悦孜学院在线培训系统上线</span>
                                <span>2020-03-30</span>
                            </div>
                            <div @click="learnGuide('news2')">
                                <span>食品企业如何快速打造专属培训学院</span>
                                <span>2020-03-30</span>
                            </div> -->
                            <div v-for="(itemN,indexN) in newsDataList" :key="indexN" @click="newsDetail(itemN.id)">
                                <span>{{itemN.noticeTitle}}</span>
                                <span>{{itemN.publishTime ? itemN.publishTime.slice(0,10) : "暂无时间"}}</span>
                            </div>
                        </div>
                        <div class="noData" v-if="newsShow">暂无数据</div>
                    </div>
                </el-col>
            </el-row>
            <!-- 中间：培训中心 -->
            <el-row class="mainCenter">
                <div class="trainCenter">
                    <div class="comHeader">
                        <span>培训中心(Training Center)</span>
                        <span @click="goPage('./train')">更多(more)</span>
                    </div>
                    <div v-if="!trainShow">
                        <div class="trainCont" v-for="(item8, index8) in trainDataList" :key="'L' + index8" >
                            <div class="comHeader" v-if="item8.category ? true : false">
                                <!-- <div v-for="(tItem,tIndex) in item8.resourceListVo" :key="tIndex">
                                    <span v-if="tItem.relatedResource.length > 0 ? true : false">{{item8.category.name}}</span>
                                </div> -->
                                 <span>{{item8.category.name}}</span>
                            </div>
                            <div class="secondClassify" v-for="(nItem,nIndex) in item8.allCourseVo" :key="nIndex">
                                <div class="trainCont" v-if="nItem.courseList.length">
                                    <div class="relate">
                                        <div>{{nItem.category.name}}</div>
                                    </div>
                                    <div class="trainItem" v-for="(item2,index2) in nItem.courseList" :key="index2" @click="goPage('./trainDetail?id=' + item2.courseId + '&url=index' + '&coursename=' + item2.courseName)">
                                        <div class="t_cont">
                                            <img :src="item2.thumbnailUrl ? $config.baseApi + item2.thumbnailUrl  : $config.baseApi + item2.picUri" alt="">
                                            <p class="resourceName">{{item2.courseName}}</p>
                                            <p>主讲人：{{item2.teacherName ?item2.teacherName : "暂无"}}</p>
                                             <!-- <p class="lock_p">学习状态：<span class="studyStatus" :id="item2.learnCount > 0 ? 'active' : '' ">{{item2.learnCount > 0 ? '已学习' : '未学习'}}</span>
                                            </p>
                                            <img v-if="item2.locked == 1 ? true : false" class="lock" src="../../../assets/images/common/lock3.png" alt=""> -->
                                            <p>学习进度：<el-progress :percentage="parseFloat(item2.process)" :color="customColorMethod" :stroke-width="7" ></el-progress></p>
                                        </div>
                                        <div class="start" >开始学习</div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="noData" v-if="trainShow">暂无数据</div>
                </div>
            </el-row>
            <!-- 底部 -->
            <el-row :gutter="10" class="mainFoot removeMargin hide">
                <!-- 我的收藏 -->
                <el-col :xs="24" :sm="12" :md="12" :lg="12" class="removePading">
                    <div class="myCollect">
                        <div class="comHeader">
                            <span>我的收藏</span>
                            <span @click="goPage('./collect')">更多</span>
                        </div>
                        <div class="comCont" v-if="!collectShow">
                            <div v-for="(item3,index3) in collectDataList" :key="index3">
                                <span>{{item3.name}}</span>
                                <span>{{item3.createTime ? item3.createTime.slice(0,10) : "暂无时间"}}</span>
                            </div>
                        </div>
                        <div class="noData" v-if="collectShow">暂无数据</div>
                    </div>
                </el-col>
                <!-- 错题集 -->
                <el-col :xs="24" :sm="12" :md="12" :lg="12" class="removePading">
                    <div class="mistakes">
                        <div class="comHeader">
                            <span>错题集</span>
                            <span @click="goPage('./mistakes')">更多</span>
                        </div>
                        <div class="comCont" v-if="!mistakeShow">
                            <div v-for="(item4,index4) in mistakeDataList" :key="index4">
                                <span>{{item4.name}}</span>
                                <span>{{item4.createTime ? item4.createTime.slice(0,10) :"暂无时间"}}</span>
                            </div>
                        </div>
                        <div class="noData" v-if="mistakeShow">暂无数据</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="footer">
            <div class="f_p">
                <div class="f_left">
                    <div class="top">
                        PHONE<br>
                        电话：
                        <img src="../../../assets/images/common/phone.png" alt="">
                    </div>
                    <div class="center">{{phone}}</div>
                    <div class="bot"></div>
                </div>
                <div class="f_center">
                    <div class="top">
                        EMAIL<br>
                        邮箱：
                        <img src="../../../assets/images/common/message.png" alt="">
                    </div>
                    <div class="center">{{email}}</div>
                    <div class="bot"></div>
                </div>
                <div class="f_right">
                    <div class="f_title">课程学习指南</div>
                    <div @click="learnGuide(1)">如何获取培训及测试资源？</div>
                    <div @click="learnGuide(2)">如何获取专业培训及测评证书？</div>
                    <div @click="learnGuide(3)">如何获得定制化在线培训系统服务？</div>
                </div>
            </div>
            <!-- pc备案号 -->
            <div class="pc_icp">
                ICP备案证书号：沪ICP 17019082号 上海悦孜企业信息咨询有限公司提供技术支持
            </div>
            <div class="mobleFooter">
                <div class="mobel_f_center">
                    <div>{{phone}}</div>
                    <div>{{email}}</div>
                </div>
                <div class="moble_f_right">
                    <div class="f_title">课程学习指南</div>
                    <div @click="learnGuide(1)">如何获取培训及测试资源？</div>
                    <div @click="learnGuide(2)">如何获取专业培训及测评证书？</div>
                    <div @click="learnGuide(3)">如何获得定制化在线培训系统服务？</div>
                </div>
                <div class="copyright">
                    <div>ICP备案证书号：沪ICP 17019082号</div>
                    <div>上海悦孜企业信息咨询有限公司提供技术支持</div>
                </div>
            </div>
            
        </div>
        <div class="indexNav">
            <div class="navLeft">
                <img src="../../../assets/images/common/headLogo.png" alt="" v-if="isShowTopLogo">
                <img :src="$config.baseApi + logo" alt="" v-else>
                <div class="n_txt">
                    <div>{{companyName}}</div>
                    <div>ONLINE ACADEMY</div>
                </div>
            </div>
            <div class="navCenter">
            </div>
            <div class="navRight">
                <div class="navRightLittleBox">
                    <div class="navRightLittle">
                        <div class="messInfo">
                            <span :id="$store.state.user.isLogin ? '' : 'hidden'">1</span>
                        </div>
                        <div class="mgInfo">
                            <div class="headImg">
                                <img :src="headimgurl" alt="">
                            </div>
                            <div class="name">{{nickname}} {{companyName2}} {{$store.state.user.isLogin ? "/" : ""}} {{departmentName}}</div>
                        </div>
                        <div class="outLogin" @click="$store.state.user.isLogin ? centerDialogVisible = true : goPage('/login')">
                            {{$store.state.user.isLogin ? "退出" : "登录"}}
                        </div>
                    </div>
                    <div class="endTime" v-if="$store.state.user.isLogin">使用期截止：{{limitLoginTime ? limitLoginTime.slice(0,10) : ''}}，剩余{{remainingTime ? remainingTime : ''}}天</div>
                    <div class="lesson_count">总课程{{totalCount}}门、已学习{{completeCount}}门、未完成{{unCompleteCount}}门</div>
                </div>
            </div>
        </div>
        <!-- 弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            :width="dialogWidth"
            center>
            <span>是否确定退出</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="outLogins()">确 定</el-button>
            </span>
        </el-dialog>
        <!--底部的详情-->
        <el-dialog
            :visible.sync="footerDialogVisible"
            :width="dialogWidth2"
            class="footerTip">
            <span>
                <div>{{guideTxtTitle}}</div>
                <p v-html="guideTxt"></p>
            </span>
        </el-dialog>
        <!-- 填写用户信息 -->
        <el-dialog title="用户信息" 
                    :visible.sync="dialogFormVisible2" 
                    center
                    :close-on-press-escape="false" 
                    :width="dialogWidth"
                    class="commonDialog">
            <el-form :model="form2" ref="form2">
                <el-form-item label="姓名" prop="name" :label-width="formLabelWidth" :rules="{required: true, message:'姓名不能为空'}">
                    <el-input v-model="form2.name" type="name" autocomplete="off" placeholder=" 请输入考生姓名"></el-input>
                </el-form-item>
                 <el-form-item label="公司" prop="company" :label-width="formLabelWidth" :rules="{required: true, message:'公司不能为空'}">
                    <el-input v-model="form2.company" type="company" autocomplete="off" placeholder=" 请输入公司"></el-input>
                </el-form-item>
                <el-form-item label="部门" prop="department" :label-width="formLabelWidth" :rules="{required: true, message:'部门不能为空'}">
                    <el-input v-model="form2.department" type="department" autocomplete="off" placeholder=" 请输入部门"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="mobile" :label-width="formLabelWidth" :rules="rules.mobile">
                    <el-input v-model="form2.mobile" type="mobile" autocomplete="off" placeholder=" 请输入联系方式"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="makeSure('form2')">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 剩余使用时间通知弹框 -->
        <el-dialog
            title="通知"
            :visible.sync="noticeDialogVisibles"
            class="noticeDialogVisible"
            width="30%"
            :before-close="noticeHandleClose">
            <div class="dialogBody">
                <div>您的账户于{{limitLoginTime ? limitLoginTime.slice(0,10) : ''}}日到期</div>
                <div>请您联系管理员进行续费：</div>
                <div>电话：15345655287</div>
                <div>邮箱：info@iqc-china.com</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="noticeHandleClose()">好的</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    // swiper的js导入
    import Swiper from "../../../assets/js/swiper/swiper.js";
    import getQuery from '../../../assets/js/libs/getQuery'
    export default {
        data(){
            var checkphone = (rule, value, callback) => {
		      if (value == "") {
		        callback(new Error("联系方式不能为空"));
		      } else if (!this.isCellPhone(value)) {
		        callback(new Error("请输入正确的手机号!"));
		      } else {
		        callback();
		      }
		    };
            return {
                swiperData : "",
                isShow:false,
                listShow:false,
                trainShow:false,
                collectShow:false,
                mistakeShow:false,
                newsShow:false,
                paperDataList:"",
                trainDataList:[],
                collectDataList:"",
                mistakeDataList:"",
                newsDataList:"",
                isShowLogo:false,
                phone:"400-168-2866",
                email:"Academy@iqc-china.com",
                companyName:"悦咨在线培训学院",
                isShowTopLogo:true,
                logo:"",
                nickname:"请先登录",
                nickname:"",
                headimgurl:"https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
                centerDialogVisible:false,
                dialogWidth:"30%",
                dialogWidth2:"40%",
                footerDialogVisible:false,
                newTrainDataList:[],
                guideTxt:"",
                guideTxtTitle:"",
                // 帮助说明
                helpImg1: require('../../../assets/images/guidance/1.png'),
                helpImg2: require('../../../assets/images/guidance/2.png'),
                helpImg3: require('../../../assets/images/guidance/3.png'),
                helpImg4: require('../../../assets/images/guidance/4.png'),
                helpImg5: require('../../../assets/images/guidance/5.png'),
                helpImg6: require('../../../assets/images/guidance/6.png'),
                helpImg7: require('../../../assets/images/guidance/7.png'),
                helpImg8: require('../../../assets/images/guidance/8.png'),
                helpImg9: require('../../../assets/images/guidance/9.png'),
                helpImg10: require('../../../assets/images/guidance/10.png'),
                dialogFormVisible2:false,
                form2: {
                    name: '',
                    company:'',
                    department: '',
                    mobile:''
                },
                rules: {
                    mobile: [
                        {required: true,validator: checkphone, trigger: 'blur'}
                    ]
                },
                formLabelWidth: '65px',
                companyName2:'',
                departmentName:"",
                totalCount:'',
                completeCount:'',
                unCompleteCount:'',
                percentage: "", //进度条百分比
                limitLoginTime:'', // 到期时间
                remainingTime:'', //剩余时间
                noticeDialogVisibles:false,//剩余时间弹框
                ShowNoticeDialog:window.sessionStorage.getItem('ShowNoticeDialog'),
            }
        },
        methods:{
            isCellPhone(val) {
                if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
                    return false;
                } else {
                    return true;
                }
            },
            customColorMethod(percentage) {
                if (percentage < 30) {
                    return '#f56c6c';
                } else if (percentage < 70) {
                    return '#e6a23c';
                } else {
                    return '#67c23a';
                }
            },
            goPage(url){
                this.$router.push(url);
            },
            outLogins(){
                this.centerDialogVisible = false;
                this.$store.commit('user/outLogin');
                this.$message({
                    message :"退出成功",
                    type:'success'
                });
                setTimeout(()=>{
                    window.location.reload();
                    this.isShowTopLogo = true
                    this.companyName = "悦咨在线培训学院",
                    this.phone = "400-168-2866",
                    this.email = "info@iqc-china.com",
                    // window.localStorage.setItem('nickname', "请先登录")
                    window.localStorage.setItem('nickname', "")
                    window.localStorage.setItem('headimgurl', "")
                    window.localStorage.setItem('companyName2', "")
                    window.localStorage.setItem('departmentName', "")
                    this.nickname = window.localStorage.getItem('nickname');
                    this.headimgurl = window.localStorage.getItem('headimgurl');
                     this.companyName2 = window.localStorage.getItem('companyName2');
                    this.departmentName = window.localStorage.getItem('departmentName');
                    this.$router.push('./login')
                },1000)
            },
            // banner
            companyInfo(){
                // let url = this.$config.baseApi + "/account/company/default"
                // if (this.$store.state.user.isLogin) {
                //     url = this.$config.baseApi + "/account/company/wx"
                // }
                // 无论新老用户都调用登录后的页面
                let url = this.$config.baseApi + "/account/company/wx"
                this.$ajax({
                    url:url,
                    method:'post',
                }).then(res=>{
                    if(res.code == 1){
                        if(res.data.banner != "[]"){
                            this.swiperData = JSON.parse( res.data.banner)
                        }else{
                            this.isShow = true;
                        }
                        if(res.data.mobile){
                            this.phone = res.data.mobile
                        }
                        if(res.data.email){
                            this.email = res.data.email
                        }
                        if(res.data.companyName){
                            this.companyName = res.data.companyName
                        }
                        if(res.data.logo){
                            this.isShowTopLogo = false
                            this.logo = res.data.logo
                        }
                        // 因为这个是在created里运行，要想获取dom，用nextTick
                        this.$nextTick(()=>{
                            new Swiper(this.$refs['swiper-container'],{
                                pagination: {
                                    el: this.$refs['swiper-pagination'],
                                    clickable :true, //点击分页器的指示点分页器会控制Swiper切换。
                                },
                                loop : true, //无缝循环
                                effect : 'fade',
                                speed:2000,
                                autoplay: {
                                    disableOnInteraction: false,
                                },
                            })
                        })
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 考试中心
            paperList() {
                // let url = this.$config.baseApi + "/examination/paper/public/list";
                // if (this.$store.state.user.isLogin) {
                //     url = this.$config.baseApi + "/examination/paper/history/list";
                // }
                let url = this.$config.baseApi + "/examination/paper/history/list";
                this.$ajax({
                    url: url,
                    method: "post",
                    data: JSON.stringify({
                        useFlag:"",
                        current:1,
                        pageSize:7 //当前只展示7条数据
                    })
                }).then(res => {
                    if (res.code == 1) {
                        this.paperDataList = res.data.records;
                        // console.log(this.paperDataList);
                        if(res.data.total == 0){
                            this.listShow = true;
                        }
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 培训中心
            trainList(){
                // let url = this.$config.baseApi + "/account/wx/resource/public_list"
                // if (this.$store.state.user.isLogin) {
                //     url = this.$config.baseApi + "/account/wx/resource/list"
                // }
                // 无论新老用户都调用登录后的页面
                let url = this.$config.baseApi + "/account/wx/resource/list"

                this.$ajax({
                    url:url,
                    method:'post',
                    data:{}
                }).then(res=>{
                    if(res.code == 1){
                        if(res.data == undefined){
                            this.trainShow = true //无数据
                        }else{
                            if(res.data.length == 0){
                                this.trainShow = true //无数据
                            }else{
                                this.trainDataList = res.data
                                // let arr = res.data;
                                // for (let i in arr) {
                                //     if(arr[i].resourceListVo){
                                //         this.newTrainDataList.push(arr[i])
                                //     }
                                // }
                                // if(this.newTrainDataList.length == 0){
                                //     this.trainShow = true //无数据
                                // }else{
                                //     this.trainDataList = this.newTrainDataList.slice(0,100);
                                // }
                            }
                        }
                        
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 收藏中心
            collectList(){
                let url = this.$config.baseApi + "/examination/favorite/list";
                this.$ajax({
                    url: url,
                    method: "post",
                    data:JSON.stringify({
                        searchName:"",
                        current:1,
                        pageSize:7, 
                    })
                }).then(res => {
                    if (res.code == 1) {
                        if(res.data.total == 0){
                            this.collectShow = true
                        }else{
                            this.collectDataList = res.data.records
                        }
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 错题集
            mistakeList(){
                let url = this.$config.baseApi + "/examination/mistake/list";
                this.$ajax({
                    url: url,
                    method: "post",
                    data:JSON.stringify({
                        searchName:"", //资源名
                        current:1,//	当前页
                        pageSize:7, //每页个数
                    })
                }).then(res => {
                    if (res.code == 1) {
                        if(res.data.total == 0){
                            this.mistakeShow = true
                        }else{
                            this.mistakeDataList = res.data.records
                        }
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 新闻公告
            getNews(){
                let url = this.$config.baseApi + "/notice/reception/list";
                this.$ajax({
                    url: url,
                    method: "post",
                    data:JSON.stringify({
                        type:"", //公告类型 2表示子公司发的，1表示总后台发
                        current:1,
                        pageSize:7, 
                    })
                }).then(res => {
                    if (res.code == 1) {
                        if(res.data.total){
                            this.newsDataList = res.data.records.splice(0,7)
                            // console.log(this.newsDataList);
                        }else{
                            this.newsShow = true
                        }
                    }else{
                        this.newsShow = true
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 新闻公告详情
            newsDetail(noticeId){
                let url = this.$config.baseApi + "/notice/detail/";
                this.$ajax({
                    url: url + noticeId,
                    method: "get",
                }).then(res => {
                    if (res.code == 1) {
                        this.learnGuide('news',res.data)
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            // 说明弹窗
            learnGuide(index,item){
                this.footerDialogVisible = true;
                switch(index) {
                    case 1 :
                            this.guideTxtTitle = "如何获取培训及测试资源？"
                            this.guideTxt = "&nbsp;&nbsp;&nbsp;&nbsp;本系统首页培训课程及试卷为公开资源，若想获得更多专属培训学习材料，请与系统管理员联系，获得授权培训教材及试卷链接后便可长期持续的进行专业学习。";
                        break;
                    case 2 :
                            this.guideTxtTitle = "如何获取专业培训及测评证书？"
                            this.guideTxt = "&nbsp;&nbsp;&nbsp;&nbsp;在本系统学习完系列培训课程后，便会获得行业权威单位颁发的培训证书，学习的越多，获取的证书越多。参加测试并获得优异成绩，亦可获得相应学科的考试测评证书。";
                        break;
                    case 3 :
                            this.guideTxtTitle = "如何获得定制化在线培训系统服务？"
                            this.guideTxt = "&nbsp;&nbsp;&nbsp;&nbsp;本系统由我们订制开发，帮助企业打造自己的培训测评学习系统。我们会持续开发不同类型的培训及测试教材，并可根据您企业的培训需求定制化开发主题课程及培训计划。系统合作、课程定制、建议反馈请与我们联系。电话：" + this.phone +" 邮箱：" + this.email;
                        break;
                    case 4 :
                            this.guideTxtTitle = "帮助说明"
                            this.guideTxt = "<img src=" + this.helpImg1 +" alt=''><img src=" + this.helpImg2 +" alt=''><img src=" + this.helpImg3 +" alt=''><img src=" + this.helpImg4 +" alt=''><img src=" + this.helpImg5 +" alt=''><img src=" + this.helpImg6 +" alt=''><img src=" + this.helpImg7 +" alt=''><img src=" + this.helpImg8 +" alt=''><img src=" + this.helpImg9 +" alt=''><img src=" + this.helpImg10 +" alt=''>";
                        break;
                    case 'news' :
                            this.guideTxtTitle = item.noticeTitle
                            this.guideTxt = item.content;
                        break;
                    default:
                            this.guideTxtTitle = "暂无数据"
                            this.guideTxt = "暂无数据";    
                }
            },
            showMessage(){
                this.dialogFormVisible2 = true;
                this.getUserInfo()
            },
            // 判断是否录入用户信息
            getUserInfo(){
                 this.$ajax({
                    url:this.$config.baseApi + "/account/wx/info",
                    method:'post'
                }).then(res=>{
                    // console.log(res)
                    if(res.code == 1){
                       this.form2.name = res.data.realName ? res.data.realName : "";
                       this.form2.mobile = res.data.mobile ? res.data.mobile : "";
                       this.form2.department = res.data.departmentName ? res.data.departmentName : "";
                       this.form2.company = res.data.companyName ? res.data.companyName : "";
                    //    this.endTime = res.data.data.limitLoginTime ? res.data.data.limitLoginTime : ""
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 需要填写信息
            makeSure(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.dialogFormVisible2 = false;
                        var _this = this
                        this.$ajax({
                            url:this.$config.baseApi + "/account/wx/change/info",
                            method:'post',
                            data:JSON.stringify({
                                'realName':_this.form2.name,
                                'mobile':_this.form2.mobile,
                                'companyName':_this.form2.company,
                                'departmentName':_this.form2.department,
                            })
                        }).then(res=>{
                            // console.log(res)
                            if(res.code == 1){
                                this.$message({
                                    message:res.msg,
                                    type:'success'
                                })
                                this.dialogFormVisible2 = false
                            }else{
                                this.$message({
                                    message:res.msg,
                                    type:'error'
                                })
                            }
                        }).catch(err =>{
                            console.log(err)
                        })
                    } else {
                        return false;
                    }
                });
            },
            //计算剩余时间
            getRemainingTime() {
                let timestampNow = Date.parse(new Date())
                let timestamp = Date.parse(this.limitLoginTime) 
                this.remainingTime = parseInt((timestamp - timestampNow) / (1000*3600*24))
                
            },
            noticeHandleClose(done) {
                this.$confirm('确认关闭？')
                .then(_ => {
                    this.noticeDialogVisibles = false
                    window.sessionStorage.setItem('ShowNoticeDialog',false)
                })
                .catch(_ => {

                });
            },
            isShowNoticeDialog() {
                let timestampNow = Date.parse(new Date())
                let limitLoginTime = window.localStorage.getItem('limitLoginTime')
                let timestamp = Date.parse(limitLoginTime) 
                let time = parseInt((timestamp - timestampNow) / (1000*3600*24))
                if(time<=30) {
                    if(this.ShowNoticeDialog == 'true') {
                    //    this.noticeDialogVisibles = true
                       this.noticeDialogVisibles = false
                    }
                }
            },
            // 查询课程数量
            getAccountCount() {
                let url = this.$config.baseApi + "/account/wx/resource/count";
                this.$ajax({
                    url: url,
                    method: "post",
                }).then(res => {
                    if (res.code == 1) {
                        this.totalCount = res.data.totalCount
                        this.completeCount = res.data.completeCount
                        this.unCompleteCount = res.data.unCompleteCount
                    }
                }).catch(err => {
                    console.log(err);
                });

            }
        },
        created() {
            this.isShowNoticeDialog()
        },
        activated(){
            this.getAccountCount()
            this.nickname = window.localStorage.getItem('nickname');
            this.headimgurl = window.localStorage.getItem('headimgurl');
            this.companyName = window.localStorage.getItem('companyName');
            this.companyName2 = window.localStorage.getItem('companyName2');
            this.departmentName = window.localStorage.getItem('departmentName');
            this.limitLoginTime = window.localStorage.getItem('limitLoginTime');
            this.getRemainingTime()
            let aLogo = window.localStorage.getItem('logo');
            if(aLogo){
                this.logo = aLogo;
                this.isShowTopLogo = false
            }
            this.companyInfo();
            this.paperList();
            this.trainList();
            this.getNews();
            if(this.$IsPc()){
                this.dialogWidth = "80%";
                this.dialogWidth2 = "80%"
            };
            let link = window.location.href;
            if(link.indexOf('companyId') != -1){
                localStorage['linkConpanyId'] = getQuery('companyId');
            }
        },
        mounted(){
            document.title=this.$route.meta.title
        }
    }
</script>

<style scoped>
    @import "../../../assets/css/home/home.css";
    /* 引入swiper中的css */
    @import "../../../assets/js/swiper/swiper.css";

    .hide {
        display: none;
    }
    .asideNav .training {
        display: flex;
        align-items: center;
        height: 0.75rem;
        padding-left: .3rem;
    }
    .training .text {
        padding-left:.1rem;
        display: flex;
        flex-direction: column;
    }
    .text .chinese {
        margin-bottom: .05rem;
    }
    .training .image img {
        width: .2rem;
    }
    .endTime,.lesson_count {
        font-size: .14rem;
    }
</style>
